<template>
    <div class="resume-recharge-page">
        <section class="page-section quota-section">
            <div class="section-title"><i></i><span>简历充值管理</span></div>
            <div class="quota-cards">
                <div class="quota-card total-card">
                    <span>充值总金额</span><strong style="border: 1px solid #E0EEFB;">{{ amountText(quota.file_total) }}<em>元</em></strong></div>
                <div class="quota-card used-card">
                    <span>已使用金额</span><strong  style="border: 1px solid #D9EBDE;;">{{ amountText(quota.file_used) }}<em>元</em></strong></div>
                <div class="quota-card balance-card">
                    <span>剩余总金额</span><strong  style="border: 1px solid #F8E9D9;">{{ amountText(quota.file_open) }}<em>元</em></strong></div>
            </div>
            <div v-if="quotaLoadError" class="balance-tip is-error"><i class="el-icon-info"></i>{{ quotaLoadError }}<el-button
                    type="text" @click="getQuota">重新加载</el-button></div>
            <div v-else class="balance-tip" :class="{ 'is-empty': quotaLoaded && isQuotaEmpty }"><i class="el-icon-info" style="vertical-align: middle;"></i>{{ balanceTipText }}</div>
            <el-button type="primary" class="renew-button" @click="renew">去续费</el-button>
        </section>

        <section class="page-section usage-section">
            <div class="section-title usage-title" style="padding-right: 10px;box-sizing: border-box;"><i></i><span>简历使用列表</span><span class="usage-count">已看简历 <strong>{{ usedResumeCount }}</strong> 份</span></div>
            <div class="toolbar">
                <div class="search-bar">
                    <el-input v-model="keyword" class="search-input" placeholder="可按姓名、学校、专业、学历等搜索生源" clearable
                        @keyup.enter.native="search"><i slot="prefix" class="el-icon-search"></i></el-input>
                    <el-button type="text" @click="search">搜索</el-button>
                    <el-button type="text" class="reset-button" @click="resetSearch">重置</el-button>
                </div>
                <el-button class="filter-button" plain :class="{ 'is-active': hasFilters }"
                    @click="filterVisible = !filterVisible">筛选<img src="https://oss.sx985.com/2026/09/02/screen-black.png" alt="" /></el-button>
            </div>
            <div v-show="filterVisible" class="filter-panel">
                <button type="button" class="filter-select" @click="openSchoolFilter">
                    <span>{{ filters.schools.length ? filters.schools.join('，') : '请选择学生所在学校' }}</span><i class="el-icon-arrow-down"></i>
                </button>
                <button type="button" class="filter-select" @click="openMajorFilter">
                    <span>{{ filters.majors.length ? filters.majors.join('，') : '请选择专业要求' }}</span><i class="el-icon-arrow-down"></i>
                </button>
                <el-select v-model="filters.educations" multiple clearable
                    placeholder="请选择学生学历" @change="search"><el-option v-for="item in educationOptions" :key="item"
                        :label="item" :value="item"></el-option></el-select>
            </div>
            <div v-if="loadError" class="load-error">{{ loadError }}<el-button type="text"
                    @click="getList">重新加载</el-button></div>
            <el-table v-loading="loading" :data="rows" row-key="uid" class="usage-table" empty-text="暂无简历使用记录"
                @row-click="previewHistory">
                <el-table-column label="学生姓名" min-width="130"><template slot-scope="scope">
                        <div class="student-name-cell">
                            <img v-if="getResumeAvatarUrl(scope.row) && !avatarLoadFailed[getResumeAvatarKey(scope.row, scope.$index)]"
                                :src="getResumeAvatarUrl(scope.row)" @error="handleResumeAvatarError(scope.row, scope.$index)" alt="">
                            <span v-else class="student-avatar-text">{{ getResumeAvatarName(scope.row) }}</span>
                            <span>{{ displayName(scope.row) }}</span>
                        </div>
                    </template></el-table-column>
                <el-table-column label="专业" min-width="180"><template
                        slot-scope="scope">{{ scope.row.smajor || scope.row.major_name || '--' }}</template></el-table-column>
                <el-table-column label="学历" min-width="130"><template
                        slot-scope="scope">{{ scope.row.edu || scope.row.education || '--' }}</template></el-table-column>
                <el-table-column label="学校" min-width="210"><template
                        slot-scope="scope">{{ scope.row.school_name || '--' }}</template></el-table-column>
            </el-table>
            <el-pagination v-if="total > pageSize" class="pagination" background layout="prev, pager, next"
                :current-page="page" :page-size="pageSize" :total="total" @current-change="changePage"></el-pagination>
        </section>

        <el-dialog title="专业要求" :visible.sync="majorFilterVisible" width="800px" @close="multipleChange = false">
            <multiple-choice :select-list="filters.majors" :multiple-change="multipleChange"
                @submit="applyMajorFilter" @cancel="majorFilterVisible = false"></multiple-choice>
        </el-dialog>

        <el-dialog title="学生所在学校" :visible.sync="schoolFilterVisible" width="800px" @close="multipleChange = false">
            <multiple-choice2 :select-list="filters.schools" :multiple-change="multipleChange"
                @submit="applySchoolFilter" @cancel="schoolFilterVisible = false"></multiple-choice2>
        </el-dialog>

        <el-dialog title="充值续费" :visible.sync="rechargeVisible" width="526px" :close-on-click-modal="false"
            class="recharge-dialog">
            <div class="recharge-title"><i></i><span>请充值（元）</span></div>
            <el-input ref="rechargeAmountInput" v-model="rechargeAmount" class="recharge-input" placeholder="请输入充值金额"
                @input="handleRechargeAmountInput">
                <!-- <i slot="suffix" class="el-icon-edit-outline"></i> -->
                <img slot="suffix" class="el-icon-edit-outline" style="width: 16px;height:16px;display: inline-block;" src="https://oss.sx985.com/2026/06/02/editnew.png" @click="$refs.rechargeAmountInput.focus()" />
            </el-input>
            <p class="recharge-tip"><i class="el-icon-info"></i> 每份简历30元，请充值30元的倍数~</p>
            <div class="recharge-title recharge-select-title"><i></i><span>可选择固定充值金额</span></div>
            <div class="recharge-options">
                <button v-for="amount in rechargeOptions" :key="amount" type="button"
                    :class="{ 'is-selected': Number(rechargeAmount) === amount }"
                    @click="selectRechargeAmount(amount)">
                    <strong>{{ amount }}元</strong>
                    <span>简历{{ amount / pricePerResume }}份</span>
                </button>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="rechargeVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmRecharge" style="text-align: center;">充值</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="paymentVisible" width="1000px" :show-close="false" :close-on-click-modal="false"
            :close-on-press-escape="false" class="resume-payment-dialog" @close="closePaymentDialog">
            <div class="resume-payment-shell">
                <img class="resume-payment-close" @click="requestClosePayment" src="../img/close.png" alt="关闭" />
                <div class="resume-payment-main">
                    <div class="flex-h">
                        <div class="resume-payment-main-title flex1">支付方式一：微信扫码支付</div>
                        <div class="resume-offline-title flex1" style="transform: translateX(58px);">支付方式二：线下对公打款</div>
                    </div>
                    <div class="resume-payment-container">
                        <div class="resume-payment-qrcode">
                            <div class="resume-payment-wechat-icon"></div>
                            <qrcode-vue class="resume-payment-qrcode-image" :value="paymentCodeUrl" :size="200"
                                color="#000000" bg-color="#ffffff"></qrcode-vue>
                            <div class="resume-payment-tip">请用微信扫码支付 <span>¥{{ amountText(rechargeAmount) }}</span>
                            </div>
                            <div class="resume-payment-warning"><img
                                    src="https://oss.sx985.com/2023/03/24/sanjiaoxing1.png" alt="" />
                                <span>支付过程中请勿关闭本页面，否则充值将失败。</span></div>
                        </div>
                        <div class="resume-offline-payment">
                            
                            <div class="resume-offline-card">
                                <div class="resume-offline-step">1. 按如下对公账号打款</div>
                                <div class="resume-offline-account">
                                    <div><span>账户名：</span><strong>武汉升学就业在线科技股份有限公司</strong></div>
                                    <div><span>账户号：</span><strong>3202 0064 0920 0062 096</strong></div>
                                    <div><span>开户银行：</span><strong>中国工商银行股份有限公司武汉地铁支行</strong></div>
                                </div>
                                <div class="resume-offline-service">
                                    <div class="resume-offline-step">2. 付款后，将付款截图发给微信客服</div>
                                    <div class="resume-offline-qrcode"></div>
                                    <div>扫码联系客服</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    import QrcodeVue from 'qrcode.vue'
    import MultipleChoice from '../components/multipleChoice.vue'
    import MultipleChoice2 from '../components/multipleChoice2.vue'

    export default {
        data() {
            return {
                loading: false,
                loadError: '',
                quotaLoaded: false,
                quotaLoading: false,
                quotaLoadError: '',
                keyword: '',
                searchedKeyword: '',
                filterVisible: false,
                majorFilterVisible: false,
                schoolFilterVisible: false,
                multipleChange: false,
                filters: {
                    schools: [],
                    majors: [],
                    educations: []
                },
                educationOptions: ['大专', '本科', '硕士', '博士'],
                page: 1,
                pageSize: 10,
                total: 0,
                rows: [],
                quota: {
                    file_total: null,
                    file_used: null,
                    file_open: null,
                    canUseNum: null,
                    usedCount: null
                },
                pricePerResume: 30,
                rechargeVisible: false,
                rechargeAmount: 300,
                rechargeOptions: [90, 300, 600, 900, 1200, 1800],
                paymentVisible: false,
                rechargeMessage: null,
                paymentCodeUrl: '',
                paymentInterval: null,
                paymentCloseConfirmVisible: false,
                paymentCloseConfirmAutoClosed: false,
                avatarLoadFailed: {}
            }
        },
        computed: {
            ...mapState({
                adminId: state => state.admin_id || (state.schoolData && state.schoolData.admin_id),
                schoolInfo: state => state.schoolData || {},
                userInfo: state => state.userInfo || {}
            }),
            availableResumeCount() {
                return this.safeNumber(this.quota.canUseNum, null)
            },
            usedResumeCount() {
                return this.safeNumber(this.quota.usedCount, 0)
            },
            quotaTotal() {
                return this.safeNumber(this.quota.file_total, null)
            },
            quotaBalance() {
                return this.safeNumber(this.quota.file_open, null)
            },
            isQuotaEmpty() {
                return this.quotaBalance === 0 && this.availableResumeCount === 0
            },
            hasQuotaBalance() {
                return this.quotaTotal !== null && this.quotaBalance !== null
            },
            giftResumeCount() {
                if (!this.hasQuotaBalance || this.availableResumeCount === null) return 0
                const giftCount = this.availableResumeCount - this.quotaBalance / this.pricePerResume
                return giftCount > 0 ? giftCount : 0
            },
            balanceTipText() {
                if (!this.hasQuotaBalance) return '当前余额 -- 元'
                if (this.isQuotaEmpty) return '账户余额不足，暂不支持新简历查看，请续费恢复服务（30元/份）。'
                if (this.quotaTotal === 0 && this.quotaBalance === 0 && this.availableResumeCount > 0) {
                    return `当前余额 0 元，可免费查看 ${this.amountText(this.availableResumeCount)} 份简历（${this.pricePerResume}元/份）！`
                }

                const giftText = this.giftResumeCount > 0 ? `（${this.pricePerResume}元/份，其中${this.amountText(this.giftResumeCount)}份赠送）！` : '（30元/份）！'
                return `当前余额 ${this.amountText(this.quotaBalance)} 元，可查看 ${this.amountText(this.availableResumeCount)} 份简历${giftText}`
            },
            hasFilters() {
                return this.filters.schools.length > 0 || this.filters.majors.length > 0 || this.filters.educations
                    .length > 0
            }
        },
        mounted() {
            this.resetScrollTop()
            this.getQuota()
            this.getList()
        },
        activated() {
            this.resetScrollTop()
            this.getQuota()
        },
        beforeDestroy() {
            clearInterval(this.paymentInterval)
        },
        beforeRouteLeave(to, from, next) {
            if (!this.paymentVisible) {
                next()
                return
            }
            this.confirmClosePayment(() => next(), () => next(false))
        },
        methods: {
            resetScrollTop() {
                this.$nextTick(() => {
                    const scrollContainer = this.$parent && this.$parent.$refs && this.$parent.$refs.scrollContainer
                    if (scrollContainer) scrollContainer.scrollTop = 0
                })
            },
            safeNumber(value, fallback) {
                if (value === null || value === undefined || (typeof value === 'string' && value.trim() === '')) return fallback
                const number = Number(value)
                return Number.isFinite(number) ? number : fallback
            },
            amountText(amount) {
                const value = this.safeNumber(amount, null)
                if (value === null) return '--'
                return Number.isInteger(value) ? value : value.toFixed(2)
            },
            getQuota() {
                this.quotaLoading = true
                this.quotaLoadError = ''
                this.$util.get('https://np.sx985.com/v2/getCompanyResumeQuota', {
                    admin_id: this.adminId || ''
                }, res => {
                    if (Number(res.code) !== 200 || !res.data) {
                        this.quotaLoadError = res.msg || '额度信息加载失败，请稍后重试。'
                    } else {
                        const data = res.data
                        this.quota = {
                            file_total: data.file_total,
                            file_used: data.file_used,
                            file_open: data.file_open,
                            canUseNum: data.canUseNum,
                            usedCount: data.usedCount
                        }
                    }
                    this.quotaLoaded = true
                    this.quotaLoading = false
                }, () => {
                    this.quotaLoaded = true
                    this.quotaLoading = false
                    this.quotaLoadError = '额度信息加载失败，请稍后重试。'
                }, null, true)
            },
            getList() {
                this.loading = true
                this.loadError = ''
                this.$util.get('https://np.sx985.com/v2/getResumeLogs', {
                    admin_id: this.adminId || '',
                    keyword: this.searchedKeyword.replace(/%/g, ''),
                    school_name: this.filters.schools.length ? JSON.stringify(this.filters.schools) : '',
                    edu: this.filters.educations.length ? JSON.stringify(this.filters.educations) : '',
                    smajor: this.filters.majors.length ? JSON.stringify(this.filters.majors) : '',
                    page: this.page,
                    pageSize: this.pageSize
                }, res => {
                    if (Number(res.code) === 200) {
                        const data = res.data || {}
                        const rows = Array.isArray(data.data) ? data.data : (Array.isArray(data.list) ? data.list : [])
                        this.rows = rows.map(row => {
                            const avatar = String(row.avatar || '')
                            return avatar.indexOf('http') === -1 ? Object.assign({}, row, { gender: row.avatar }) : row
                        })
                        this.total = this.safeNumber(data.total, this.rows.length)
                    } else {
                        this.rows = []
                        this.total = 0
                        this.loadError = res.msg || '简历使用记录加载失败'
                    }
                    this.loading = false
                }, () => {
                    this.loading = false
                    this.loadError = '简历使用记录加载失败，请稍后重试'
                }, null, true)
            },
            search() {
                this.searchedKeyword = this.keyword
                this.page = 1
                this.getList()
            },
            resetSearch() {
                this.keyword = ''
                this.searchedKeyword = ''
                this.filters = {
                    schools: [],
                    majors: [],
                    educations: []
                }
                this.page = 1
                this.getList()
            },
            openMajorFilter() {
                this.multipleChange = true
                this.majorFilterVisible = true
            },
            openSchoolFilter() {
                this.multipleChange = true
                this.schoolFilterVisible = true
            },
            applyMajorFilter(values) {
                this.filters.majors = values
                this.majorFilterVisible = false
                this.search()
            },
            applySchoolFilter(values) {
                this.filters.schools = values
                this.schoolFilterVisible = false
                this.search()
            },
            changePage(page) {
                this.page = page
                this.getList()
            },
            displayName(row) {
                return row.realname || row.username || row.name || '--'
            },
            getResumeAvatarKey(row, index) {
                return `${row.uid || row.user_id || row.id || 'student'}-${index}`
            },
            getResumeAvatarUrl(row) {
                const avatar = String(row.avatar || '')
                if (avatar.indexOf('http') !== -1) return avatar

                const userId = String(row.uid || row.user_id || row.id || '')
                const lastDigit = userId.slice(-1)
                const userIdNumber = Number(userId)
                if (!/^\d$/.test(lastDigit) || Number(lastDigit) < 4 || !Number.isFinite(userIdNumber)) {
                    return ''
                }

                const baseUrl = 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/01/05'
                const gender = Number(row.gender)
                if (gender === 2) return `${baseUrl}/nv${userIdNumber % 25}.png`
                if (gender === 1) return `${baseUrl}/nan${userIdNumber % 21}.png`
                return `${baseUrl}/wu${userIdNumber % 9}.png`
            },
            getResumeAvatarName(row) {
                return String(this.displayName(row)).slice(-2)
            },
            handleResumeAvatarError(row, index) {
                this.$set(this.avatarLoadFailed, this.getResumeAvatarKey(row, index), true)
            },
            previewHistory(row) {
                if (row.url) window.open(row.url, '_blank')
            },
            downloadHistory(row) {
                if (!row.url) return
                const link = document.createElement('a')
                link.href = row.url
                link.download = ''
                link.target = '_blank'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            },
            renew() {
                this.rechargeAmount = 300
                this.rechargeVisible = true
            },
            selectRechargeAmount(amount) {
                this.rechargeAmount = amount
            },
            handleRechargeAmountInput(value) {
                this.rechargeAmount = value.replace(/[^\d]/g, '')
            },
            showRechargeMessage(type, message) {
                if (this.rechargeMessage) {
                    this.rechargeMessage.close()
                }
                this.rechargeMessage = this.$message({
                    type,
                    message
                })
            },
            confirmRecharge() {
                const rechargeAmount = String(this.rechargeAmount)
                if (rechargeAmount.startsWith('0')) {
                    this.showRechargeMessage('warning', '充值金额首位不能为0')
                    return
                }
                const amount = Number(rechargeAmount)
                if (!amount || amount % 30 !== 0) {
                    this.showRechargeMessage('warning', '请输入30元的倍数')
                    return
                }
                this.createRechargeOrder(amount)
            },
            createRechargeOrder(amount) {
                const remark = `简历充值${amount}元`
                const orderData = {
                    uid: this.userInfo.user_id,
                    pname: this.schoolInfo.company_name,
                    pmobile: this.userInfo.tel,
                    goods_id: 150,
                    spec_id: 0,
                    order_price: amount,
                    source: 3,
                    remark,
                    order_json: JSON.stringify({
                        name: this.schoolInfo.company_name,
                        tel: this.userInfo.tel,
                        p_name: this.userInfo.username,
                        remark
                    }),
                    company_id: this.adminId || this.schoolInfo.admin_id
                }
                this.$util.post('v2/orderCampus', orderData, res => {
                    if (Number(res.code) !== 200 || !res.data || !res.data.order_no) {
                        this.showRechargeMessage('error', res.msg || '创建订单失败')
                        return
                    }
                    this.$util.post('v2/campusPay', {
                        uid: this.userInfo.user_id,
                        pay_money: amount,
                        order_id: res.data.order_no,
                        order_name: '简历充值'
                    }, paymentRes => {
                        if (Number(paymentRes.code) !== 200 || !paymentRes.msg) {
                            this.showRechargeMessage('error', paymentRes.msg || '支付失败！')
                            return
                        }
                        this.rechargeVisible = false
                        this.paymentCodeUrl = paymentRes.msg.code_url
                        this.paymentVisible = true
                        clearInterval(this.paymentInterval)
                        this.paymentInterval = setInterval(() => {
                            this.getRechargeOrderInfo(paymentRes.msg.out_trade_no)
                        }, 1000)
                    })
                })
            },
            getRechargeOrderInfo(orderNo) {
                this.$util.get('v2/getCampusOrderInfo', {
                    order_no: orderNo,
                    uid: this.userInfo.user_id
                }, res => {
                    if (Number(res.code) !== 200) {
                        clearInterval(this.paymentInterval)
                        this.paymentVisible = false
                        this.showRechargeMessage('error', res.msg || '支付失败！')
                        return
                    }
                    if (Number(res.data && res.data.order_status) !== 1) return
                    clearInterval(this.paymentInterval)
                    if (this.paymentCloseConfirmVisible) {
                        this.paymentCloseConfirmAutoClosed = true
                        this.paymentCloseConfirmVisible = false
                        this.$msgbox.close()
                    }
                    this.paymentVisible = false
                    this.getQuota()
                    this.showRechargeMessage('success', '充值成功')
                })
            },
            requestClosePayment() {
                this.confirmClosePayment()
            },
            confirmClosePayment(onConfirm, onCancel) {
                if (this.paymentCloseConfirmVisible) {
                    if (onCancel) onCancel()
                    return
                }
                this.paymentCloseConfirmAutoClosed = false
                this.paymentCloseConfirmVisible = true
                this.$confirm('支付过程中请勿关闭微信扫码支付页面，否则充值将失败。', '提示', {
                    confirmButtonText: '继续支付',
                    cancelButtonText: '取消支付',
                    type: 'warning',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showClose: false
                }).then(() => {
                    this.paymentCloseConfirmVisible = false
                    if (onCancel) onCancel()
                }).catch(() => {
                    const isAutoClosed = this.paymentCloseConfirmAutoClosed
                    this.paymentCloseConfirmAutoClosed = false
                    this.paymentCloseConfirmVisible = false
                    if (isAutoClosed) {
                        if (onCancel) onCancel()
                        return
                    }
                    this.paymentVisible = false
                    if (onConfirm) onConfirm()
                })
            },
            closePaymentDialog() {
                clearInterval(this.paymentInterval)
                this.getQuota()
            }
        },
        components: {
            QrcodeVue,
            MultipleChoice,
            MultipleChoice2
        }
    }
</script>

<style scoped>
    .resume-recharge-page {
        min-height: 100%;
        padding: 32px 25px 46px;
        background: #f7f8fc;
        font-size: 14px;
        box-sizing: border-box;
    }

    .page-section {
        position: relative;
        max-width: none;
        margin: 0 0 20px;
        padding: 0;
        background: transparent;
        box-sizing: border-box;
    }

    .quota-section {
        width: 730px;
        min-height: 214px;
        margin-bottom: 72px;
    }

    .section-title {
        display: flex;
        align-items: center;
        color: #222;
        font-size: 18px;
        font-weight: 700;
        line-height: 18px;
    }

    .section-title i {
        width: 8px;
        height: 17px;
        margin-right: 4px;
        border-radius: 4px;
        background: #3d73f5;
    }

    .quota-cards {
        display: flex;
        width: 730px;
        height: 165px;
        margin-top: 30px;
        padding: 16px 10px;
        border-radius: 10px;
        background: #fff;
        box-shadow: none;
        box-sizing: border-box;
    }

    .quota-card {
        flex: 1;
        width: auto;
        height: 87px;
        padding: 15px 0 0;
        margin-right: 15px;
        border-radius: 10px;
        text-align: center;
        box-sizing: border-box;
    }

    .quota-card:last-child {
        margin-right: 0;
    }

    .total-card {
        background: #eaf4fd;
    }

    .used-card {
        background: #e8f6ec;
    }

    .balance-card {
        background: #fdf4ea;
    }

    .quota-card span {
        display: block;
        color: #535659;
        font-size: 14px;
        font-weight: 400;
    }

    .quota-card strong {
        display: inline-block;
        /* min-width: 106px; */
        margin: 6px auto 0;
        /* padding: 7px 10px; */
        border-radius: 4px;
        background: #F9FBFF;
        color: #000;
        font-size: 24px;
        line-height: 26px;
        height: 38px;
        width: 95%;
        text-align: center;
        line-height: 38px;
    }

    .quota-card em {
        margin-left: 2px;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #1E252B;
    }

    .balance-tip {
        position: absolute;
        top: 166px;
        right: auto;
        left: 10px;
        width: 711px;
        height: 30px;
        margin: 0;
        padding: 7px 10px 0;
        overflow: hidden;
        border-radius: 5px;
        background: #eaf4fd;
        color: #4b4b4b;
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
        white-space: nowrap;
        box-sizing: border-box;
    }

    .balance-tip.is-empty {
        color: #4b4b4b;
    }

    .balance-tip.is-error {
        color: #f56c6c;
    }

    .balance-tip.is-error .el-button {
        margin-left: 8px;
        padding: 0;
    }

    .balance-tip i {
        margin-right: 5px;
        color: #7b8492;
        font-size: 15px;
    }

    .renew-button {
        position: absolute;
        top: -6px;
        right: 9px;
        width: 98px;
        height: 36px;
        padding: 0;
        border: 0;
        border-radius: 5px;
        background: #3d73f5;
        font-size: 16px;
        font-weight: 700;
    }

    .usage-section {
        width: 730px;
        min-height: 603px;
        margin-top: 0;
        padding: 17px 14px 14px;
        border-radius: 10px;
        background: #fff;
        box-shadow: none;
        overflow: visible;
    }

    .usage-section .section-title {
        position: absolute;
        top: -44px;
        right: 0;
        left: 0;
    }

    .usage-count {
        margin-left: auto;
        color: #535659;
        font-size: 14px;
        font-weight: 400;
    }

    .usage-count strong {
        color: #3d73f5;
        font-weight: 700;
    }

    .toolbar {
        display: flex;
        align-items: center;
        margin: 0 0 20px;
    }

    .search-bar {
        display: flex;
        flex: 1;
        align-items: center;
        min-width: 0;
        padding: 0 12px 0 0;
        border-radius: 4px;
        background: #f6f7fb;
    }

    .search-input {
        flex: 1;
        width: auto;
    }

    .search-input /deep/ .el-input__inner {
        height: 40px;
        padding-left: 42px;
        border: 0;
        border-radius: 4px;
        background: transparent;
        font-size: 14px;
    }

    .search-input /deep/ .el-input__prefix {
        left: 15px;
        line-height: 40px;
        color: #656b73;
    }

    .search-bar .el-button--text {
        margin-left: 0;
        padding: 0;
        color: #1357f6;
        font-size: 14px;
        font-weight: 600;
    }

    .search-bar .reset-button {
        position: relative;
        /* margin-left: 12px; */
        padding-left: 13px;
    }

    .search-bar .reset-button::before {
        position: absolute;
        top: 50%;
        left: 0;
        width: 1px;
        height: 16px;
        background: #d9dce2;
        content: '';
        transform: translateY(-50%);
    }

    .filter-button {
        width: 108px;
        height: 39px;
        margin-left: 20px;
        color: #2a2a2a;
        border: 0;
        border-radius: 5px;
        background: #f6f7fb;
        font-size: 14px;
        font-weight: 700;
    }

    .filter-button img {
        width: 14px;
        height: 14px;
        margin-left: 5px;
        vertical-align: -2px;
    }

    .filter-button.is-active {
        color: #1357f6;
        border-color: #a9c3ff;
    }

    .filter-panel {
        display: flex;
        gap: 12px;
        margin: 0 0 10px;
        padding: 8px;
        background: #f7f8fc;
    }

    .filter-panel .el-select {
        width: 31%;
    }

    .filter-panel .el-select /deep/ .el-input__inner::placeholder {
        color: #606266;
        opacity: 1;
    }

    .filter-select {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 31%;
        min-width: 0;
        height: 40px;
        padding: 0 12px;
        overflow: hidden;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        background: #fff;
        color: #606266;
        cursor: pointer;
        font-size: 14px;
        text-align: left;
    }

    .filter-select span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .filter-select i {
        flex: none;
        margin-left: 8px;
        color: #c0c4cc;
    }

    .load-error {
        width: 708px;
        max-width: 100%;
        margin-bottom: 12px;
        color: #f56c6c;
    }

    .load-error .el-button {
        margin-left: 8px;
        padding: 0;
    }

    .usage-table {
        width: 100%;
    }

    .usage-table /deep/ th {
        height: 40px;
        background: #f6f7fb;
        color: #0e0e0e;
        font-size: 14px;
        font-weight: 700;
    }

    .usage-table /deep/ th .cell {
        color: #0e0e0e;
        font-weight: 700;
    }

    .usage-table /deep/ td {
        height: 43px;
        color: #3d4652;
        font-size: 14px;
    }

    .student-name-cell {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .student-name-cell img,
    .student-avatar-text {
        width: 20px;
        height: 20px;
        flex: none;
        border-radius: 50%;
    }

    .student-avatar-text {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        background: #e8eeff;
        color: #1765e6;
        font-size: 10px;
        line-height: 20px;
    }

    .usage-table /deep/ .el-table__body tr {
        cursor: pointer;
    }

    .usage-table /deep/ th,
    .usage-table /deep/ td {
        border-bottom: 0;
    }

    .usage-table /deep/ .el-table__body tr:nth-child(even) > td {
        background: #f6f7fb;
    }

    .pagination {
        width: 100%;
        margin-top: 22px;
        text-align: right;
    }

    .recharge-dialog /deep/ .el-dialog {
        position: absolute;
        top: 50%;
        left: 50%;
        margin: 0;
        border-radius: 5px;
        transform: translate(-50%, -50%);
    }

    .recharge-dialog /deep/ .el-dialog__header {
        padding: 19px 20px 15px;
        border-bottom: 1px solid #edf0f5;
    }

    .recharge-dialog /deep/ .el-dialog__title {
        color: #262626;
        font-size: 16px;
        font-weight: 700;
    }

    .recharge-dialog /deep/ .el-dialog__headerbtn {
        top: 17px;
        right: 19px;
    }

    .recharge-dialog /deep/ .el-dialog__close {
        color: #333;
        font-size: 18px;
        font-weight: 700;
    }

    .recharge-dialog /deep/ .el-dialog__body {
        padding: 18px 30px 12px;
    }

    .recharge-title {
        display: flex;
        align-items: center;
        color: #30343b;
        font-size: 14px;
        font-weight: 700;
    }

    .recharge-title i {
        width: 3px;
        height: 14px;
        margin-right: 7px;
        border-radius: 2px;
        background: #3d73f5;
    }

    .recharge-input {
        margin-top: 11px;
      
    }

    .recharge-input /deep/ .el-input__inner {
        height: 40px;
        border: 0;
        border-radius: 6px;
        background: #edf6ff;
        color: #30343b;
        font-weight:bold;
    }

    .recharge-input /deep/ .el-input__suffix {
        right: 13px;
        line-height: 40px;
        color: #6d7785;
        font-size: 18px;
    }

    .recharge-tip {
        margin: 11px 0 26px;
        color: #7d8490;
        font-size: 12px;
        line-height: 18px;
    }

    .recharge-tip i {
        margin-right: 4px;
        color: #8b9db8;
    }

    .recharge-select-title {
        margin-bottom: 18px;
    }

    .recharge-options {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
    }

    .recharge-options button {
        width: calc((100% - 24px) / 3);
        height: 70px;
        padding: 0;
        color: #4b535f;
        border: 1px solid #d9e8fa;
        border-radius: 6px;
        background: #fff;
        cursor: pointer;
    }

    .recharge-options button strong,
    .recharge-options button span {
        display: block;
    }

    .recharge-options button strong {
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        color:#000;
    }

    .recharge-options button span {
        color: #8b93a0;
        font-size: 12px;
        line-height: 18px;
    }

    .recharge-options button.is-selected {
        color: #fff;
        border-color: #3d73f5;
        background: #3d73f5;
    }

    .recharge-options button.is-selected span {
        color: #fff;
    }
    .recharge-options button.is-selected strong {
        color: #fff;
    }

    .recharge-dialog /deep/ .el-dialog__footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 22px 30px 28px;
    }

    .recharge-dialog /deep/ .el-dialog__footer .el-button {
        width: 80px;
        height: 36px;
        padding: 0;
        border-radius: 4px;
        font-size: 13px;
    }

    .recharge-dialog /deep/ .el-dialog__footer .el-button--default {
        color: #626b78;
        border-color: #d8e8fa;
        background: #edf6ff;
    }

    .recharge-dialog /deep/ .el-dialog__footer .el-button--primary {
        border-color: #3d73f5;
        background: #3d73f5;
    }

    .resume-payment-dialog {
        display: flex;
        align-items: center;
    }

    .resume-payment-dialog /deep/ .el-dialog {
        width: 980px !important;
        max-width: calc(100vw - 32px);
        margin: 0 auto !important;
        border-radius: 0;
        background: transparent;
        box-shadow: none;
        transform: none !important;
    }

    .resume-payment-dialog /deep/ .el-dialog__header {
        display: none;
    }

    .resume-payment-dialog /deep/ .el-dialog__body {
        padding: 0;
    }

    .resume-payment-shell {
        position: relative;
        font-size: 0;
    }

    .resume-payment-main {
        box-sizing: border-box;
        padding: 30px 48px 58px;
        border-radius: 8px;
        background: #fff;
    }

    .resume-payment-main-title,
    .resume-offline-title {
        margin: 0 0 24px;
        padding-left: 12px;
        border-left: 4px solid #1e40af;
        color: #2a2929;
        font-size: 22px;
        font-weight: 700;
        line-height: 24px;
    }

    .resume-payment-close {
        position: absolute;
        top: -28px;
        right: -28px;
        width: 32px;
        height: 32px;
        cursor: pointer;
    }

    .resume-payment-container {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 52px;
    }

    .resume-payment-qrcode {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 400px;
        padding: 16px 0 0;
        overflow: hidden;
        border: 4px solid #e9eef2;
        border-radius: 14px;
        background: #fff;
        min-width: 400px;
    }

    .resume-payment-wechat-icon {
        width: 30px;
        height: 34px;
        background: url('https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/15/hwqylu4nxq08pfnu.png') center top / 30px 30px no-repeat;
    }

    .resume-payment-qrcode-image {
        margin: 14px 0 24px;
    }

    .resume-payment-tip {
        margin-bottom: 22px;
        color: #333;
        font-size: 18px;
        font-weight: 500;
        line-height: 24px;
    }

    .resume-payment-tip span {
        color: #00c800;
        font-size: 24px;
        font-weight: 700;
    }

    .resume-payment-warning {
        box-sizing: border-box;
        display: flex;
        align-items: flex-start;
        width: 100%;
        min-height: 76px;
        padding: 14px 14px 13px;
        background: #fff7e6;
        color: #606266;
        font-size: 16px;
        line-height: 26px;
    }

    .resume-payment-warning img {
        width: 18px;
        height: 16px;
        flex: none;
        margin: 4px 8px 0 0;
    }

    .resume-offline-payment {
        position: relative;
        box-sizing: border-box;
        width: 400px;
        padding-left: 16px;
    }

    .resume-offline-payment::before {
        position: absolute;
        top: 0;
        bottom: 0;
        left: -38px;
        width: 1px;
        border-left: 1px dashed #d9d9d9;
        content: '';
        transform: scaleY(.9);
    }

    .resume-offline-title {
        margin: 0 0 28px;
    }

    .resume-offline-card {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        height: 420px;
        overflow: hidden;
        border: 4px solid #e9eef2;
        border-radius: 14px;
        background: #fff;
        color: #222;
        font-size: 16px;
    }

    .resume-offline-step {
        padding: 16px;
        background: #eef3ff;
        font-size: 16px;
        line-height: 22px;
    }

    .resume-offline-account {
        padding: 10px 16px 24px;
    }

    .resume-offline-account>div {
        display: flex;
        align-items: center;
        margin-top: 12px;
        white-space: nowrap;
    }

    .resume-offline-account span {
        width: 80px;
        flex: none;
    }

    .resume-offline-account strong {
        box-sizing: border-box;
        flex: 1;
        padding: 4px 12px;
        border-radius: 16px;
        background: #eef3ff;
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
    }

    .resume-offline-service {
        flex: 1;
        padding-bottom: 16px;
        background: #eef3ff;
        text-align: center;
        font-size: 14px;
        line-height: 20px;
    }

    .resume-offline-service .resume-offline-step {
        padding: 14px 16px 12px;
        text-align: left;
    }

    .resume-offline-qrcode {
        width: 96px;
        height: 96px;
        margin: 0 auto 8px;
        background: #fff url('https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/02/21/wv4br98vawxpxkei.png') center / contain no-repeat;
    }

    @media screen and (max-width: 1100px) {
        .filter-panel {
            flex-wrap: wrap;
        }
    }

</style>
